import { BoxProps } from "@chakra-ui/react";
import { qoriaColours } from "@/theme/colours";

/**
 * `main.scss` hides every scrollbar app-wide (`::-webkit-scrollbar { display: none }`),
 * so each scrollable area has to opt back in. Matches the student list and target picker.
 */
export const scrollbarProps: BoxProps["sx"] = {
	"&::-webkit-scrollbar": { display: "block", width: "8px" },
	"&::-webkit-scrollbar-thumb": {
		background: qoriaColours.brand.neutral[50],
		borderRadius: "8px",
	},
	"&::-webkit-scrollbar-track": { background: "transparent" },
	scrollbarWidth: "thin",
	scrollbarColor: `${qoriaColours.brand.neutral[50]} transparent`,
};
